import { useMissionsTranslation } from '../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import { TableContainer } from './TableContainer';
import { usePagination } from './hooks/usePagination';
export function ParticipantTable(props) {
    const { allRows, columns, readonly, rowsPerPageOptions, showTableBorder, showToolbarBorder, tableRowActions, toolbar, showTableHead, emptyTableView, totalRows, onRowClick, isLoading, } = props;
    const [selected, setSelected] = React.useState([]);
    const { currentPageRows, currentPageNumber, rowsPerPage, rowsPerPageOptionValues, handleChangeRowsPerPage, handleChangePage } = usePagination(allRows, rowsPerPageOptions);
    const selectedRows = allRows.filter((row) => selected.includes(row.id));
    const areAllRowsSelected = allRows.every((currentRow) => selected.includes(currentRow.id));
    const { t } = useMissionsTranslation();
    const isSelected = (rowId) => selected.includes(rowId);
    const handleCheckboxClick = (rowId) => {
        const selectedIndex = selected.indexOf(rowId);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, rowId);
        }
        else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        }
        else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        }
        else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    };
    const handleSelectAllClick = () => {
        if (areAllRowsSelected) {
            setSelected([]);
        }
        else {
            setSelected(allRows.map((row) => row.id));
        }
    };
    const handleSelectReset = (rowIds) => {
        if (!rowIds) {
            setSelected([]);
        }
        else {
            setSelected((prevState) => prevState.filter((selectedItem) => !rowIds.includes(selectedItem)));
        }
    };
    let content;
    if (currentPageRows.length <= 0 && emptyTableView) {
        content = emptyTableView;
    }
    else {
        content = (React.createElement(TableContainer, { rows: currentPageRows, rowSpan: totalRows, emptyRows: currentPageNumber > 0 ? Math.max(0, (1 + currentPageNumber) * rowsPerPage - totalRows) : 0, columns: columns, page: currentPageNumber, rowsPerPage: rowsPerPage, readonly: readonly, showBorders: showTableBorder, showTableHead: showTableHead, rowsPerPageOptions: rowsPerPageOptionValues, indeterminate: selected.length > 0 && !areAllRowsSelected, allItemsSelected: areAllRowsSelected, onCheckboxClick: handleCheckboxClick, onRowClick: onRowClick, onPageChange: (event, newPage) => {
                handleChangePage(event, newPage);
            }, onRowsPerPageChange: (event) => {
                handleChangeRowsPerPage(event);
            }, handleSelectAllClick: handleSelectAllClick, isRowSelected: isSelected, rowActions: (row) => tableRowActions === null || tableRowActions === void 0 ? void 0 : tableRowActions(row, handleSelectReset) }));
    }
    return (React.createElement(Box, null,
        React.createElement(Box, { sx: [showToolbarBorder ? { border: `1px solid ${themeColors.border.main}`, borderRadius: 0.5 } : {}] },
            toolbar &&
                toolbar({
                    selectedRows,
                    multiSelect: {
                        handleSelectAllRows: handleSelectAllClick,
                        allItemsSelected: areAllRowsSelected,
                    },
                    handleSelectReset,
                }),
            toolbar && !showTableBorder && React.createElement(Divider, null)),
        isLoading ? (React.createElement(Typography, null, t('common.loading'))) : (React.createElement(Box, { sx: [
                showTableBorder && currentPageRows.length > 0
                    ? {
                        border: `1px solid ${themeColors.border.main}`,
                        borderRadius: 0.5,
                    }
                    : {},
            ] }, content))));
}
